export default "__VITE_ASSET__C6ZN2VAF__"